export default __webpack_public_path__ + "static/media/60.514b80f5.jpg";